import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
  public closeModal$ = new Subject<void>();

  public closeModal(): void {
    this.closeModal$.next();
  }
}
